import { marked } from 'marked';
import TurndownService from 'turndown';
// @ts-expect-error no published types for this plugin
import { gfm } from 'turndown-plugin-gfm';

const VARIABLE_PREFIX = '\u200BVAR_PLACEHOLDER_';
const VARIABLE_SUFFIX = '_END_PLACEHOLDER\u200B';

function escapeVariables(markdown: string): { escaped: string; names: string[] } {
    const names: string[] = [];
    const escaped = markdown.replace(/\{\{(\w+)\}\}/g, (_match, name) => {
        names.push(name);
        return `${VARIABLE_PREFIX}${name}${VARIABLE_SUFFIX}`;
    });
    return { escaped, names };
}

function restoreVariables(html: string): string {
    const regex = new RegExp(
        `${VARIABLE_PREFIX.replace('\u200B', '\\u200B')}(\\w+)${VARIABLE_SUFFIX.replace('\u200B', '\\u200B')}`,
        'g',
    );
    return html.replace(regex, '<span data-type="variable" data-name="$1"></span>');
}

function wrapBareListItems(html: string): string {
    return html.replace(
        /<li>(?!\s*<(?:p|ul|ol|blockquote|pre|h[1-6])[ >])([\s\S]*?)<\/li>/g,
        '<li><p>$1</p></li>',
    );
}

function trimCodeBlockTrailingNewline(html: string): string {
    return html.replace(/<pre><code([^>]*)>([\s\S]*?)\n<\/code><\/pre>/g, '<pre><code$1>$2</code></pre>');
}

export function markdownToHtml(markdown: string): string {
    if (!markdown) return '<p></p>';

    const { escaped } = escapeVariables(markdown);

    let html = marked.parse(escaped, { async: false, gfm: true, breaks: false }) as string;

    html = wrapBareListItems(html);
    html = trimCodeBlockTrailingNewline(html);
    html = restoreVariables(html);

    return html || '<p></p>';
}

export function htmlToMarkdown(html: string): string {
    if (!html) return '';

    const turndown = new TurndownService({
        headingStyle: 'atx',
        codeBlockStyle: 'fenced',
        bulletListMarker: '-',
        emDelimiter: '_',
        strongDelimiter: '**',
    });

    turndown.use(gfm);

    turndown.addRule('variable', {
        filter(node) {
            return (
                node.nodeName === 'SPAN' &&
                node.getAttribute('data-type') === 'variable'
            );
        },
        replacement(_content, node) {
            const name = (node as HTMLElement).getAttribute('data-name') || 'variable';
            return `{{${name}}}`;
        },
    });

    turndown.addRule('strikethrough', {
        filter(node) {
            const tagName = node.nodeName.toLowerCase();
            return tagName === 'del' || tagName === 's' || tagName === 'strike';
        },
        replacement(content) {
            return `~~${content}~~`;
        },
    });

    let markdown = turndown.turndown(html);

    markdown = markdown.replace(/\n{3,}/g, '\n\n').trim();

    return markdown;
}
